import AuthWall from '../../../components/auth-wall';
import {observer} from 'mobx-react';
import Tabs from '../components/tabs/tabs';
import './networkAnalysisPage.scss';
import {useContext, useEffect, useMemo} from 'react';
import {NetworkContext} from '../lib/context';
import CompareToggle from '../components/compare-toggle';
import RosterComparisonSummary from '../components/roster-comparison-summary';
import NetworkAnalysisGeographyFilter from '../components/no-filters/network-analysis-geography-filter';
import DisruptionAnalysisFilter from '../components/no-filters/disruption-analysis-filter';
import RosterComparisonDisruptionAnalysis from '../components/roster-comparison-disruption-analysis';
import RevisionIdSelector from '../components/revision-id-selector';
import {useParams} from 'react-router-dom';
import {SkeletonPlaceholder} from '@carbon/react';

const PAGE_HEIGHT = 'min-h-[calc(100vh-11rem)]';

const NetworkAdequacyView = observer(() => (
    <div className="bg-background-gray-100 relative" data-testid="network-adequacy-view">
        <div className={`network-analysis-page grid grid-cols-1 grid-rows-1 gap-8 ${PAGE_HEIGHT} p-4 pl-12 mr-[calc(16rem+6rem)]`}>
            <div className="col-span-1 h-full">
                <RosterComparisonSummary />
            </div>
        </div>
        <div className='network-analysis-page absolute right-0 top-0 min-h-[calc(100%)]'>
            <NetworkAnalysisGeographyFilter
                showRosterSelection={true}
            />
        </div>
    </div>
));

const DisruptionAnalysisView = observer(() => (
    <div className="bg-background-gray-100 relative" data-testid='disruption-analysis-view'>
        <div className={`network-analysis-page grid grid-cols-1 grid-rows-1 gap-8 ${PAGE_HEIGHT} p-4 pl-12 mr-[calc(16rem+6rem)]`}>
            <div className="col-span-1 h-full">
                <RosterComparisonDisruptionAnalysis />
            </div>
        </div>
        <div className='network-analysis-page absolute right-0 top-0 h-[calc(100%)]'>
            <DisruptionAnalysisFilter
                showRosterSelection={true}
            />
        </div>
    </div>
));

function RosterComparisonPage() {
    const networkOptimizationStore = useContext(NetworkContext);
    const {rosterId, revisionId} = useParams();

    const tabs = useMemo(() => [
        {
            label: 'Network Adequacy',
            content: <NetworkAdequacyView />
        },
        {
            label: 'Disruption Analysis',
            content: <DisruptionAnalysisView />
        }
    ], []);

    const resetSelectedRosterForComparison = () => {
        if(networkOptimizationStore.selectedRosterForComparison) {
            const prevSelectedRosterId = networkOptimizationStore.selectedRosterForComparison.split('-')[0];
            networkOptimizationStore.selectedRosters = networkOptimizationStore.selectedRosters.filter((id) => id !== prevSelectedRosterId);
            networkOptimizationStore.selectedRosterForComparison = '';
        }
    };
    
    useEffect(() => {
        resetSelectedRosterForComparison();
    }, [revisionId]);

    useEffect(() => {
        return () => {
            resetSelectedRosterForComparison();
        };
    }, []);
   
    return (
        <AuthWall>
            <div className="network-analysis-page bg-white">
                <div className="flex flex-col justify-center rounded px-12 py-8 bg-white">
                    <div className="flex flex-col justify-center">
                        <h3 className="text-3xl text-[#222B36] font-normal m-0">Roster Comparison Tool</h3>
                    </div>
                    {networkOptimizationStore.rosterFileName ? 
                        <div className="m-0 mt-3 mb-4 flex space-x-5 items-center text-[14px]">
                            <div className="italic">{networkOptimizationStore.rosterFileName}</div>
                            <CompareToggle />
                        </div> :
                        <SkeletonPlaceholder className='w-48 h-5 mb-4' />
                    }
                    <RevisionIdSelector rosterId={rosterId}/>
                </div>
                <Tabs tabs={tabs} variant="default" />
            </div>
        </AuthWall>
    );
}

export default observer(RosterComparisonPage);
